import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

export default {
    async EncabezadoReporte(vm) {
        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        var formData = new FormData();
        formData.append("nrreporte", datos.nrreporte);
        formData.append("svindice", datos.svindice);
        formData.append("aiclave", datos.aiclave);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}Vial/ReporteEncabezado`, formData);
        return response.data[0];
    },
    async DetalleGeneral(vm) {
        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        datosReporte.append("aiclave", datos.aiclave);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}Vial/DetalleGeneral`, datosReporte);
        return response.data[0];
    },

    async MostrarAgregar(vm, fecha) {
        var datosReporte = new FormData();
        datosReporte.append("svfhtermino", fecha);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}Vial/MostrarAgregar`, datosReporte);
        return response.data[0];
    },
    async Movimientos(vm) {
        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}Vial/MovimientosReporteVial`, datosReporte);
        return response.data;
    },
    async AgregarMovimiento(vm, observacion) {
        let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", datos.nrreporte);
        datosReporte.append("svindice", datos.svindice);
        datosReporte.append("obs", observacion);
        let response = await vm.axios.post(`${vm.domain.domainNameForApi}Vial/AgregarMovRepVial`, datosReporte);
        return response.data;
    }
}